
import { Card, CardContent } from "@/components/ui/card";

const features = [
  "Measure their current AI capabilities through comprehensive assessment.",
  "Compare AI adoption against real-time industry benchmarks.",
  "Get a clear, actionable roadmap to improve AI implementation.",
  "Align AI initiatives with business strategy and innovation goals."
];

export const WhatIsAIMAA = () => {
  return (
    <section className="mb-8 sm:mb-16 animate-fade-in">
      <h2 className="text-xl sm:text-2xl font-semibold text-[#0f2d69] mb-4 sm:mb-6">What is AIMAA?</h2>
      <Card className="bg-white/50 hover:shadow-lg transition-all duration-300">
        <CardContent className="pt-6">
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-6">
            AIMAA is a structured AI maturity framework that helps organizations:
          </p>
          <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="text-[#0f2d69] font-semibold">•</span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
            In today's rapidly evolving technological landscape, AI adoption is no longer optional—it's a competitive necessity. 
            AIMAA ensures that organizations can systematically assess, benchmark, and advance their AI strategies with confidence.
          </p>
        </CardContent>
      </Card>
    </section>
  );
};
